<template>
  <div>
    <template v-if="!isShowAuditiont">
      <!-- 课程头图 -->
      <div v-if="shopGoodsVersion!=2 " class="product-intro" ref="productWrap" id="goodsInfo">
        <CourseResource :data="infoList" @loadImage="loadImage" @onImage="onImage"/>
      </div>
      <CourseWidgets :data="infoList" v-else ></CourseWidgets>

      <!-- 课程评论 -->
      <div class="comment-module" ref="commentWrap" v-if="shopGoodsVersion!=2 && showTypeTrue">
        <p class="module-title">课程评价</p>
        <comment-list :listData="commentList"></comment-list>
        <div class="more-comment-btn" @click="goToCommentlist">
          <span>查看更多评论</span>
          <img src="../images/more_arrow.png" alt="">
        </div>
      </div>

      <!-- 课程详情 -->
      <div class="product-detail" ref="detailWrap" v-if="shopGoodsVersion!=2 && showTypeTrue && detailList && detailList.length">
        <p class="module-title">课程详情</p>
        <CourseResource :data="detailList" @loadImage="loadImage" @onImage="onImage"/>
      </div>
    </template>

    <!-- 音视频 -->
    <template  v-else>
      <div :style="headStyle">
        <CourseHead :data="goodsDetail" :themeType="themeType"/>
      </div>

      <MediaCatalog
        id="goodsInfo"
        :style="tabsStyle"
        :sticky="sticky"
        :isLogin="isLogin"
        :courseId="goodsDetail.id"
        :productType="productType"
        :boughtCount="goodsDetail.boughtCount"
        >
        <CourseResource v-if="shopGoodsVersion !=2" :data="infoList" @loadImage="loadImage" @onImage="onImage"/>
        <CourseWidgets v-else :data="infoList"></CourseWidgets>
      </MediaCatalog>
    </template>
  </div>
</template>

<script>
import CourseResource from './resource';
import CommentList from '@/components/comment/commentList';
import { MediaCatalog, CourseHead } from '@/components/audition';
import CourseWidgets from '@/components/courseWidgets';

export default {
  name: 'CourseContent',
  components: {
    CommentList,
    CourseResource,
    MediaCatalog,
    CourseHead,
    CourseWidgets
  },
  props: {
    goodsDetail: {
      type: Object,
      default: () => ({})
    },
    headColor: {
      type: String,
      default: 'rgba(256, 256, 256, 1)'
    },
    themeType: {
      type: [String, Number],
      default: ''
    },
    infoList: {
      type: [Array, Object],
      default: () => []
    },
    commentList: {
      type: Array,
      default: () => []
    },
    detailList: {
      type: [Array, Object],
      default: () => []
    },
    showTypeTrue: {
      type: Boolean,
      default: false
    },
    sticky: {
      type: Boolean,
      default: true
    },
    // 是否登陆
    isLogin: {
      type: Boolean,
      default: false
    },

  },
  computed: {
    tabsStyle() {
      if (this.themeType) {
        return {};
      }
      return { 'margin-top': '-0.16rem' };
    },
    headStyle() {
      if (this.themeType === 'black') {
        return {
          'margin': '0.1rem',
          'background-color': '#fff',
          'border-radius': '0.19rem',
        };
      }
      return { 'background-color': this.headColor, 'padding-bottom': '0.16rem' };
    },
    // 产品类型 0-有声书 1-音频课 2-直播课 3-视频课 8-阅读计划 10 实体 11- 课包  200 家长课 300 公司活动 600 训练营
    productType() {
      return this.goodsDetail.productType;
    },
    // 内容展示方式
    isShowAuditiont() {
      return this.goodsDetail.whetherAudition && (this.goodsDetail.showType === 0);
    },
    shopGoodsVersion() {
      return this.goodsDetail.shopGoodsVersion;
    }
  },
  methods: {
    goToCommentlist() {
      this.$parent.goToCommentlist && this.$parent.goToCommentlist();
    },
    // 图片加载完成
    loadImage(index) {
      this.$parent.loadImgHandle && this.$parent.loadImgHandle();
    },
    // 点击图片
    onImage({ action, url }) {
      if (action === 'buy') {
        this.$parent.openHandle && this.$parent.openHandle({ imgClick: true });
      } else if (action === 'jump' && url) {
        this.$parent.goTo && this.$parent.goTo(url);
      }
    },
  }
};
</script>

<style lang="stylus" scoped>
.module-title {
  color #41414D
  font-size: 16px
  padding 20px
  font-weight: bold;
}

.comment-module {
  .more-comment-btn {
    display: flex;
    justify-content center
    align-items center
    margin 15px 0
    margin-bottom: 0

    span {
      color #7A7A99
      font-size: 14px
    }

    img {
      width: 16px
      height: 16px
    }
  }

}
</style>